import React from 'react';
import PropTypes from 'prop-types';

import pluralize from 'pluralize';
import AsyncSelect from 'react-select/async';
import classNames from 'classnames';
import filter from 'lodash/filter';

import ContactAndDatabaseOption from './associated_contact_selector/options/contact_and_database';
import ContactOption from './associated_contact_selector/options/contact';
import { debouncedSearchContacts } from 'components/contacts/api';

import 'styles/entity_selector.scss';

export default class AssociatedContactSelector extends React.Component {
  static propTypes = {
    autoFocus: PropTypes.bool,
    className: PropTypes.string,
    contacts: PropTypes.arrayOf(PropTypes.shape({
      contactId: PropTypes.number,
      contactType: PropTypes.string,
      name: PropTypes.string
    })),
    createText: PropTypes.string,
    databases: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired
    })),
    disabled: PropTypes.bool,
    limitToType: PropTypes.string,
    localSearch: PropTypes.bool,
    projectId: PropTypes.number,
    selectedValue: PropTypes.object,
    styles: PropTypes.object,
    type: PropTypes.oneOf(['Contacts::Company', 'Contacts::Person']),
    typeLabel: PropTypes.string,
    onCreateContact: PropTypes.func,
    onModelAdded: PropTypes.func.isRequired
  };

  state = {
    value: ''
  }

  typeLabel = this.props.typeLabel || (this.props.type == 'Contacts::Company' ? 'Company' : 'Contact');

  searchContacts(term, callback) {
    const params = { term, projectId: this.props.projectId };
    if (this.props.databases) params.databases = this.props.databases;
    if (this.props.type) {
      params.type = this.props.type;
    }

    debouncedSearchContacts(params, (contacts) => {
      const options = contacts.map((contact) => {
        return {
          ...contact,
          value: contact.id,
          label: this.labelForContact(contact),
          type: contact.contactType,
          database: contact.databaseName
        };
      });

      callback(this.filterOptionsByType(options));
    });
  }

  labelForContact = (contact) => {
    if (contact.name && contact.email) return `${contact.name} (${contact.email})`;

    return contact.name || contact.email;
  }

  contacts = (inputValue) => {
    return this.props.contacts.map((contact) => {
      if (contact.name.includes(inputValue)) {
        return {
          associatedModelType: contact.contactType,
          associatedModelId: contact.contactId,
          id: contact.contactId,
          label: contact.name,
          name: contact.name,
          value: contact.contactId,
          projectContact: true,
          type: contact.contactType
        };
      }
    }).filter(item => item);
  }

  loadContactOptions = (inputValue, callback) => {
    if (this.props.onCreateContact) {
      this.loadContactOptionsWithCreate(inputValue, callback);
    } else {
      this.searchContacts(inputValue, callback);
    }
  }

  loadContactOptionsWithCreate = (inputValue, callback) => {
    const createContact = {
      type: 'addContact',
      label: this.props.createText || `Create ${this.typeLabel}`,
      onClick: this.props.onCreateContact
    };

    if (inputValue) {
      if (this.props.localSearch && this.props.contacts.length > 0) {
        callback([...this.contacts(inputValue), createContact]);
      } else {
        this.searchContacts(inputValue, (options) => {
          callback([...options, createContact]);
        });
      }
    } else {
      callback([createContact]);
    }
  }

  filterOptionsByType = (options) => {
    if (!this.props.limitToType) return options;

    return filter(options, { type: this.props.limitToType });
  }

  onSelected = (selection) => {
    if (!selection.type || selection.type === 'addContact') return undefined;

    this.setState({ value: selection });

    const modelDetails = {
      ...selection,
      associatedModelId: selection.value,
      associatedModelType: selection.type
    };
    delete modelDetails.id;

    this.props.onModelAdded(modelDetails);
  }

  currentlySelectedValue = () => {
    if (!this.props.selectedValue) return;

    return {
      value: this.props.selectedValue.associatedModelId,
      label: this.props.selectedValue.name || this.props.selectedValue.email,
      type: this.props.selectedValue.associatedModelType
    };
  }

  render() {
    const Option = !this.props.databases || this.props.databases.length > 1 ? ContactAndDatabaseOption : ContactOption;

    return (
      <AsyncSelect
        autoFocus={this.props.autoFocus}
        className={classNames('entity-selector', this.props.className)}
        classNamePrefix=""
        components={{ Option }}
        defaultOptions={!!this.props.onCreateContact}
        isDisabled={this.props.disabled}
        loadOptions={this.loadContactOptions}
        placeholder={`Search ${pluralize(this.typeLabel)}...`}
        styles={this.props.styles}
        value={this.currentlySelectedValue()}
        onChange={this.onSelected}
      />
    );
  }
}
